(function () {
  'use strict';
  const boxTools=typeof module!=='undefined'&&module.exports?require('./eb-box-split.js'):window.EBBoxSplit;
  const handles = ['vanilla-peanut-pie', 'chocolate-sea-salt', 'banana-choco-bliss', 'lemon-blueberry-dream'];
  const names = ['Vanilla Peanut Pie', 'Chocolate Sea Salt', 'Banana Choco Bliss', 'Lemon Blueberry Dream'];
  let soldOutFlavours = [false, false, false, false];
  let availableIndices = [0, 1, 2, 3];
  const leastAvailable = values => availableIndices.reduce((best,i) => values[i] < values[best] ? i : best, availableIndices[0]);
  function splitOf(item, size) {
    try {
      const split = JSON.parse(item.properties?._eb_flavors || '{}');
      if (Object.keys(split).some(k => !handles.includes(k))) return null;
      const values = handles.map(k => split[k] || 0);
      if (values.some(n => !Number.isInteger(n) || n < 0 || n % 7) || values.reduce((a,b) => a+b,0) !== size) return null;
      if (size === 14 && values.filter(Boolean).length > 2) return null;
      return values;
    } catch (_) { return null; }
  }
  function upgradeSplit(split, size) {
    if (![28,56].includes(size) || !Array.isArray(split) || split.length !== handles.length || split.some(n => !Number.isInteger(n) || n < 0 || n % 7) || split.reduce((a,b) => a+b,0) !== size/2) throw new Error('invalid upgrade split');
    const next = [...split];
    if (!availableIndices.length) throw new Error('no available flavours');
    soldOutFlavours.forEach((soldOut,i)=>{if(soldOut) next[i]=0;});
    for (let remaining = size-next.reduce((a,b)=>a+b,0); remaining > 0; remaining -= 7) {
      next[leastAvailable(next)] += 7;
    }
    return next;
  }
  function resizedSplit(split, oldSize, size) {
    return boxTools.resize(split,oldSize,size,soldOutFlavours);
  }
  function propertiesFor(item, size, split, label, existing=false) {
    if (!existing && split.some((n,i)=>n && soldOutFlavours[i])) throw new Error('sold out flavour');
    if (!splitOf({properties:{_eb_flavors:JSON.stringify(Object.fromEntries(handles.map((h,i)=>[h,split[i]])))}},size)) throw new Error('invalid split');
    const props = {...item.properties};
    const original=splitOf(item,Number(props._eb_size)),oldText=original&&names.map((name,i)=>original[i]?name+' '+original[i]+'×':'').filter(Boolean).join(', ');
    Object.keys(props).forEach(k => {
      if (k === props._eb_flavour_label || (!k.startsWith('_') && oldText && props[k]===oldText)) delete props[k];
    });
    props[label] = names.map((n,i) => split[i] ? n+' '+split[i]+'×' : '').filter(Boolean).join(', ');
    props._eb_bundle = size === 14 ? '14 Individual Bars' : 'Box of '+size;
    props._eb_size = String(size);
    props._eb_flavors = JSON.stringify(Object.fromEntries(handles.filter((h,i)=>split[i]).map(h=>[h,split[handles.indexOf(h)]])));
    props._eb_flavour_label = label;
    delete props._eb_cart_edit;
    return props;
  }
  function planFor(tier, weeks) {
    return tier?.data?.allocations.find(a => String(a.id) === String(tier.planIds[weeks]));
  }
  function frequency(item, tier) {
    const id = item.selling_plan_allocation?.selling_plan?.id;
    return id ? Object.keys(tier.planIds).find(w=>String(tier.planIds[w])===String(id)) : null;
  }
  function comparison(tier, rate) { return tier.data.compare || (rate === 1 ? Math.round(tier.compareEur*100) : Math.round(tier.compareEur*rate)*100); }
  function addonDiscount(tier, rate, extraPrice) {
    const original=comparison(tier,rate);
    return original>0?Math.max(0,Math.min(99,Math.floor((original-extraPrice)*100/original))):0;
  }
  function upgradeCost(productDelta, currentShipping, nextQuote) {
    // The goal quote verifies free initial delivery for this exact market and plan.
    // Without both delivery quotes, do not advertise an unverified total increase.
    if (!Number.isInteger(productDelta) || !Number.isInteger(currentShipping) || currentShipping < 0 || nextQuote?.free !== true) return null;
    const delta=productDelta-currentShipping;
    return delta>0?delta:null;
  }
  function savings(items, tiers, rate) {
    return items.reduce((sum,item)=>{
      const tier = Object.values(tiers).find(t=>String(t.id)===String(item.variant_id));
      const compare = tier ? comparison(tier,rate) : item.original_price;
      return sum + Math.max(0, Math.max(compare,item.original_price)*item.quantity-item.final_line_price);
    },0);
  }
  function bundleIdentity(item,size) {
    const split=splitOf(item,size);
    if(!split) return null;
    const flavourText=names.map((name,i)=>split[i]?name+' '+split[i]+'×':'').filter(Boolean).join(', ');
    const ignored=['_eb_cart_edit','_eb_flavour_label','_eb_bundle','_eb_size','_eb_flavors'];
    const extra=Object.entries(item.properties||{}).filter(([key,value])=>!ignored.includes(key) && key!==item.properties?._eb_flavour_label && (key.startsWith('_') || value!==flavourText)).sort(([a],[b])=>a.localeCompare(b));
    return JSON.stringify([String(item.variant_id||item.id),String(item.selling_plan_allocation?.selling_plan?.id||item.selling_plan||''),split,extra]);
  }
  function findCartLine(items, original) {
    const identity=item=>JSON.stringify([String(item.variant_id||item.id),String(item.selling_plan_allocation?.selling_plan?.id||item.selling_plan||''),Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b))]);
    const matches=items.filter(item=>identity(item)===identity(original));
    return matches.find(item=>item.key===original.key) || (matches.length===1?matches[0]:null);
  }
  // A real 56-bar line provides Shopify's exact market and subscription price.
  // Its two persisted box configurations are separate editable cart rows.
  function pairSplits(item) {
    if(item.properties?._eb_pair_version!=='1') return null;
    try {
      const boxes=[JSON.parse(item.properties._eb_box_1),JSON.parse(item.properties._eb_box_2)];
      if(boxes.some(s=>!Array.isArray(s)||s.length!==4||s.some(n=>!Number.isInteger(n)||n<0||n%7)||s.reduce((a,b)=>a+b,0)!==28)) return null;
      const total=splitOf(item,56);
      return total && total.every((n,i)=>n===boxes[0][i]+boxes[1][i])?boxes:null;
    } catch (_) {return null;}
  }
  function withoutPair(item) {
    const properties={...item.properties};
    try {JSON.parse(properties._eb_box_labels||'[]').forEach(label=>delete properties[label]);} catch (_) {}
    Object.keys(properties).filter(k=>k.startsWith('_eb_box_')||k.startsWith('_eb_pair_')).forEach(k=>delete properties[k]);
    return {...item,properties};
  }
  function pairProperties(item,boxes,flavourLabel,boxLabels) {
    const sum=boxes[0].map((n,i)=>n+boxes[1][i]);
    const properties=propertiesFor(withoutPair(item),56,sum,flavourLabel,true);
    properties._eb_pair_version='1';
    properties._eb_pair_origin=item.properties?._eb_pair_origin||'paired28';
    properties._eb_pair_id=item.properties?._eb_pair_id||crypto.randomUUID();
    properties._eb_box_1=JSON.stringify(boxes[0]);properties._eb_box_2=JSON.stringify(boxes[1]);
    properties._eb_box_labels=JSON.stringify(boxLabels);
    boxes.forEach((split,i)=>{properties[boxLabels[i]]=names.map((name,j)=>split[j]?name+' '+split[j]+'×':'').filter(Boolean).join(', ');});
    return properties;
  }
  function pairCandidate(items,tiers) {
    const small=tiers[28],large=tiers[56];
    if(!small?.data || !large?.data?.available) return null;
    const groups=new Map();
    for(const item of items) {
      if(String(item.variant_id)!==String(small.id) || !Number.isInteger(item.quantity)||item.quantity<1) continue;
      const split=splitOf(item,28),weeks=frequency(item,small);
      if(!split || split.some((n,i)=>n&&soldOutFlavours[i]) || (item.selling_plan_allocation&&!weeks)) continue;
      const from=weeks?planFor(small,weeks)?.price:small.data.price,to=weeks?planFor(large,weeks)?.price:large.data.price;
      if(!Number.isInteger(from)||!Number.isInteger(to)||to<=0||to>=2*from) continue;
      const identity=JSON.parse(bundleIdentity(item,28));
      const key=JSON.stringify([weeks,identity[3]]);
      if(!groups.has(key)) groups.set(key,[]);
      const group=groups.get(key);group.push({item,split});
      if(group.reduce((n,x)=>n+x.item.quantity,0)>=2) {
        const first=group[0],second=first.item.quantity>=2?first:group[1];
        return {first:first.item,second:second.item,boxes:[first.split,second.split],weeks};
      }
    }
    return null;
  }
  function mergeUpdates(items,tiers,preferredMarker) {
    const groups=new Map(),updates={};
    items.forEach(item=>{
      const tier=Object.values(tiers).find(q=>String(q.id)===String(item.variant_id));
      const identity=tier&&bundleIdentity(item,tier.size);
      if(!identity) return;
      if(!groups.has(identity)) groups.set(identity,[]);
      groups.get(identity).push(item);
    });
    groups.forEach(group=>{
      if(group.length<2) return;
      const keeper=group.find(item=>preferredMarker && item.properties?._eb_cart_edit===preferredMarker)||group[0];
      group.forEach(item=>updates[item.key]=item===keeper?group.reduce((n,line)=>n+line.quantity,0):0);
    });
    return updates;
  }
  function upgradeEvent(item,updated,fromSize,toSize,currency,addedValue) {
    if(![14,28].includes(fromSize) || toSize!==fromSize*2 || !updated || String(updated.variant_id)===String(item.variant_id) || !Number.isFinite(addedValue) || addedValue<=0) return null;
    const plan=item.selling_plan_allocation?.selling_plan?.id;
    return {offer_id:fromSize+'_'+toSize,from_box_size:fromSize,to_box_size:toSize,quantity:item.quantity,from_variant_id:String(item.variant_id),to_variant_id:String(updated.variant_id),purchase_type:plan?'subscription':'one_time',selling_plan_id:plan?String(plan):'',currency,value:Math.round(addedValue)/100};
  }
  function liveShippingQuote(rates,currency) {
    const initialOptions=new Map();
    for(const rate of rates||[]) {
      // Shopify returns initial shipping first, then renewal shipping with the
      // same service code for subscriptions. Do not mistake a free renewal for
      // the initial delivery charge.
      const key=[rate.source,rate.code||rate.name,rate.carrier_identifier||''].join('|');
      if(!initialOptions.has(key)) initialOptions.set(key,rate);
    }
    const valid=[...initialOptions.values()].filter(r=>r.currency===currency && Number.isFinite(Number(r.price)) && Number(r.price)>=0);
    if(!valid.length) return null;
    const selected=valid.reduce((a,b)=>Number(a.price)<=Number(b.price)?a:b);
    const days=Array.isArray(selected.delivery_days) && selected.delivery_days.length && selected.delivery_days.every(d=>Number.isInteger(d)&&d>=0) ? [Math.min(...selected.delivery_days),Math.max(...selected.delivery_days)] : null;
    return {price:Math.round(Number(selected.price)*100),days};
  }
  function addBusinessDays(date, days, holidays=[]) {
    const result=new Date(date), excluded=new Set(holidays);
    for(let left=days;left>0;) {
      result.setUTCDate(result.getUTCDate()+1);
      if(![0,6].includes(result.getUTCDay()) && !excluded.has(result.toISOString().slice(0,10))) left--;
    }
    return result;
  }
  function czechHolidays(year) {
    // Gregorian Easter plus Czech fixed public holidays, recalculated every year.
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4;
    const f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30;
    const i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
    const month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;
    const easter=new Date(Date.UTC(year,month-1,day,12));
    return ['01-01','05-01','05-08','07-05','07-06','09-28','10-28','11-17','12-24','12-25','12-26'].map(v=>year+'-'+v).concat([-2,1].map(offset=>{
      const date=new Date(easter);date.setUTCDate(date.getUTCDate()+offset);return date.toISOString().slice(0,10);
    }));
  }
  function deliveryDates(config, now=new Date()) {
    if(config.shippingMode==='hidden') return null;
    const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Prague',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
    const part=key=>parts.find(p=>p.type===key).value;
    const today=new Date(part('year')+'-'+part('month')+'-'+part('day')+'T12:00:00Z');
    const originHolidays=[today.getUTCFullYear(),today.getUTCFullYear()+1].flatMap(czechHolidays);
    let dispatch=addBusinessDays(today,1,originHolidays);
    if(config.shippingMode==='preorder') {
      const match=/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(config.dispatchDate||'');
      if(match) {
        const launch=new Date(Date.UTC(Number(match[3]),Number(match[2])-1,Number(match[1]),12));
        if(launch>today) dispatch=launch;
      }
    }
    const data=config.delivery;
    if(!data?.days) return {dispatch};
    const holidays=config.country==='CZ' ? [dispatch.getUTCFullYear(),dispatch.getUTCFullYear()+1].flatMap(czechHolidays) : Object.values(data.holidays||{}).flat();
    const start=addBusinessDays(dispatch,data.days[0],holidays),end=addBusinessDays(dispatch,data.days[1],holidays);
    return {dispatch,start,end};
  }
  function shippingAddress(country,delivery) {
    const address=new URLSearchParams({'shipping_address[country]':country,'shipping_address[zip]':delivery.zip});
    if(delivery.province) address.set('shipping_address[province]',delivery.province);
    return address;
  }
  async function quoteJSON(url,options={},fetcher=fetch) {
    for(let attempt=0;attempt<3;attempt++) {
      try {
        const response=await fetcher(url,{...options,signal:AbortSignal.timeout(12000)});
        if(!response.ok) {
          const error=new Error('Quote unavailable');
          error.permanent=response.status<500 && response.status!==429;
          throw error;
        }
        return await response.json();
      } catch(error) {
        if(error.permanent || attempt===2) throw error;
        await new Promise(resolve=>setTimeout(resolve,600*(attempt+1)));
      }
    }
  }
  // Cart edits are not new purchase intent. Keep their requests outside the
  // storefront's automatic AddToCart fetch listener without changing global tags.
  function createEditTransport(doc) {
    let frame;
    return function editFetch(url, options) {
      if (!frame?.isConnected) {
        frame=doc.createElement('iframe');
        frame.hidden=true;
        frame.setAttribute('aria-hidden','true');
        frame.setAttribute('tabindex','-1');
        frame.setAttribute('title','Cart update transport');
        doc.body.appendChild(frame);
      }
      return frame.contentWindow.fetch(url,options);
    };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports={pairSplits,withoutPair,pairProperties,pairCandidate,upgradeCost,splitOf,upgradeSplit,resizedSplit,propertiesFor,planFor,frequency,savings,comparison,addonDiscount,bundleIdentity,findCartLine,mergeUpdates,upgradeEvent,createEditTransport,addBusinessDays,deliveryDates,liveShippingQuote,shippingAddress,quoteJSON}; return; }
  const el = document.getElementById('eb-cart');
  const configEl = document.getElementById('eb-cart-config');
  if (!el || !configEl || window.EBCart) return;
  const isPage=el.hasAttribute('data-ebc-page');
  let cfg;
  try { cfg=JSON.parse(configEl.textContent); } catch (_) { return; }
  soldOutFlavours = cfg.soldOutFlavours || soldOutFlavours;
  availableIndices = handles.map((h,i)=>i).filter(i=>!soldOutFlavours[i]);
  const root = (window.Shopify?.routes?.root || cfg.root || '/').replace(/\/?$/, '/');
  const strings = cfg.strings;
  const esc = s => String(s ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const t = (key,values={}) => {
    let text=strings[key]||'';
    if(key==='bars'&&strings.bar_count) {const category=values.n===0?'zero':new Intl.PluralRules(cfg.locale).select(values.n);text=strings.bar_count[category]||strings.bar_count.other;}
    return Object.entries(values).reduce((s,[k,v])=>s.replaceAll('['+k+']',String(v)),text);
  };
  const money = cents => new Intl.NumberFormat(cfg.locale,{style:'currency',currency:cart?.currency||cfg.currency,minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100);
  const rate = () => cfg.currency==='EUR' ? 1 : (Number(window.Shopify?.currency?.rate)||0);
  let cart=null, busy=false, previous=null, editing=null, focusBefore=null;
  let bodyMarkup='',footerMarkupKey='';
  let discountDraft='', discountMessage='', discountError=false, discountExpanded=false;
  const upgradeQuotes=new Map(),upgradePending=new Map();
  const upgradeQuoteStorage='eb-cart-upgrade-quotes-v1',upgradeQuoteMaxAge=3600000;
  try {
    const stored=JSON.parse(localStorage.getItem(upgradeQuoteStorage)||'[]');
    for(const [key,quote] of stored) {
      if(quote?.country===cfg.country && quote.currency===cfg.currency && typeof quote.free==='boolean' && Date.now()-Date.parse(quote.checkedAt)<upgradeQuoteMaxAge) upgradeQuotes.set(key,quote);
    }
  } catch (_) { /* Storage is optional in private browsing. */ }
  function saveUpgradeQuotes() {
    try {localStorage.setItem(upgradeQuoteStorage,JSON.stringify([...upgradeQuotes].filter(([,quote])=>Date.now()-Date.parse(quote.checkedAt)<upgradeQuoteMaxAge)));} catch (_) {}
  }
  let shippingQuote=null, shippingKey='', quoteSequence=0, shippingLoading=false, shippingQuotedAt=0, summarySnapshot=null, quoteRenderPending=false;
  function currentShippingKey() {
    return JSON.stringify([cfg.country,cart.currency,cart.total_price,cart.items.map(i=>[i.key,i.quantity,i.final_price])]);
  }
  async function quoteShipping() {
    if(!cart?.item_count || !cfg.delivery?.zip) {++quoteSequence;quoteRenderPending=false;shippingQuote=null;shippingLoading=false;shippingKey=cart?.item_count?currentShippingKey():'';render();return;}
    const key=currentShippingKey(),sequence=++quoteSequence;
    quoteRenderPending=true;
    // A page transition can reuse the exact cart's freshly verified quote.
    // Changed lines, quantities, discounts, country or currency change this key.
    if(!shippingQuote) {
      try {
        const cached=JSON.parse(sessionStorage.getItem('eb-cart-shipping-quote-v1')||'null');
        if(cached?.key===key && Date.now()-cached.at<30000 && Number.isInteger(cached.quote?.price) && cached.quote.price>=0) {
          shippingQuote=cached.quote;shippingKey=key;shippingQuotedAt=cached.at;shippingLoading=false;
          await quoteUpgrades();
          if(sequence===quoteSequence) {quoteRenderPending=false;render();}
          return;
        }
      } catch (_) {}
    }
    if(key!==shippingKey) shippingQuote=null;
    shippingKey=key;
    const address=shippingAddress(cfg.country,cfg.delivery);
    shippingLoading=true;
    const upgrades=quoteUpgrades();
    try {
      // The synchronous endpoint includes presentment currency and the LIVE
      // transit-day settings. The async endpoint omits these for this store.
      const data=await quoteJSON(root+'cart/shipping_rates.json?'+address,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(sequence!==quoteSequence || currentShippingKey()!==key) return;
      shippingQuote=liveShippingQuote(data.shipping_rates,cart.currency);shippingQuotedAt=Date.now();
      if(shippingQuote) {try {sessionStorage.setItem('eb-cart-shipping-quote-v1',JSON.stringify({key,quote:shippingQuote,at:shippingQuotedAt}));} catch (_) {}}
      const item=cart.items[0],tier=item && tierOf(item),weeks=tier && frequency(item,tier);
      if(shippingQuote && tier && cart.items.length===1 && item.quantity===1 && !(cart.discount_codes||[]).some(code=>code.applicable) && cart.total_price===price(tier,weeks) && (!item.selling_plan_allocation || weeks)) {
        upgradeQuotes.set(upgradeQuoteKey(tier,weeks),{country:cfg.country,currency:cart.currency,variant:String(tier.id),plan:weeks?String(planFor(tier,weeks).id):'',bars:tier.size,free:shippingQuote.price===0,checkedAt:new Date(shippingQuotedAt).toISOString(),receivedAt:shippingQuotedAt});saveUpgradeQuotes();
      }
    } catch (_) {if(sequence===quoteSequence) shippingQuote=null;}
    await upgrades;
    if(sequence===quoteSequence) {quoteRenderPending=false;shippingLoading=false;render();scheduleProductQuote(undefined,true);document.dispatchEvent(new Event('eb:shipping-quoted'));}
  }
  function upgradeQuoteKey(tier,weeks) {return JSON.stringify([cfg.country,String(tier.id),weeks?String(planFor(tier,weeks)?.id||''):'']);}
  function verifiedUpgrade(tier,weeks) {
    const quote=upgradeQuotes.get(upgradeQuoteKey(tier,weeks));
    return quote && Date.now()-Date.parse(quote.checkedAt)<upgradeQuoteMaxAge?quote:null;
  }
  async function quoteUpgrades() {
    // Every eligible line needs its own offer, including mixed-size carts.
    const candidates=(cart?.items||[]).flatMap(item=>{
      const tier=tierOf(item),weeks=tier && frequency(item,tier);
      if(!tier || item.quantity!==1 || (item.selling_plan_allocation && !weeks)) return [];
      return Object.values(cfg.tiers).filter(next=>next.size>tier.size && next.data?.available && (!weeks || planFor(next,weeks))).map(next=>({next,weeks}));
    });
    await Promise.all(candidates.map(async ({next,weeks})=>{
      const key=upgradeQuoteKey(next,weeks),existing=upgradeQuotes.get(key);
      if(existing && Date.now()-existing.receivedAt<30000) return;
      if(upgradePending.has(key)) return upgradePending.get(key);
      const request=(async()=>{
        try {
          const plan=weeks?String(planFor(next,weeks).id):'';
          const params=new URLSearchParams({country:cfg.country,variant:String(next.id),plan});
          const endpoint=new URL(cfg.deliveryEstimateUrl);endpoint.pathname='/goal';
          const data=await quoteJSON(endpoint+'?'+params,{credentials:'omit',cache:'no-store'});
          if(data.country!==cfg.country || data.currency!==cfg.currency || data.variant!==String(next.id) || data.plan!==plan || data.bars!==next.size || typeof data.free!=='boolean' || !Number.isFinite(Date.parse(data.checkedAt)) || Date.now()-Date.parse(data.checkedAt)>=upgradeQuoteMaxAge) throw new Error('Invalid upgrade quote');
          upgradeQuotes.set(key,{...data,receivedAt:Date.now()});saveUpgradeQuotes();
        } catch (_) {if(!verifiedUpgrade(next,weeks)) upgradeQuotes.delete(key);}
        finally {upgradePending.delete(key);}
      })();
      upgradePending.set(key,request);return request;
    }));
  }
  function freeShippingGoal() {
    const item=cart?.items?.[0],tier=item && tierOf(item),weeks=tier && frequency(item,tier);
    if(!tier || cart.items.length!==1 || item.quantity!==1 || (item.selling_plan_allocation && !weeks)) return null;
    const candidates=Object.values(cfg.tiers).filter(next=>next.size>tier.size && next.data?.available && (!weeks || planFor(next,weeks))).sort((a,b)=>a.size-b.size);
    for(const next of candidates) {
      const quote=verifiedUpgrade(next,weeks);
      if(!quote) return null;
      if(quote.free) return next.size;
    }
    return null;
  }
  let productQuote=null, productLoading=false, productAttempted=false, productKey='', productFetched=0, productSequence=0, productTimer;
  function currentProductSelection() {
    if(!document.querySelector('.eb-box-checkout')) return null;
    const order=window.EB_getOrder?.();
    if(order?.variant) return {variant:String(order.variant),plan:String(order.sellingPlan||'')};
    const size=document.querySelector('.eb-qty-tab[aria-selected="true"]')?.dataset.qty?.replace('q','')||'28';
    const tier=cfg.tiers[size];
    return tier?{variant:String(tier.id),plan:document.querySelector('.eb-box-mode input[name="selling_plan"]')?.value||''}:null;
  }
  async function quoteProduct(selection,force=false) {
    if(!selection?.variant || cfg.shippingMode==='hidden') return;
    const key=JSON.stringify([cfg.country,selection.variant,selection.plan]);
    // Reuse the live quote of this exact variant already in the visitor's cart.
    // An independent anonymous quote is needed only before it is in the cart.
    if(cart?.items?.some(item=>String(item.variant_id)===selection.variant)) {
      if(shippingQuote?.days && shippingKey===currentShippingKey() && Date.now()-shippingQuotedAt<30000) {
        ++productSequence;productKey=key;productQuote={days:shippingQuote.days};productFetched=Date.now();productLoading=false;productAttempted=true;
        document.dispatchEvent(new Event('eb:shipping-quoted'));return;
      }
      if(shippingLoading) {++productSequence;productQuote=null;productLoading=true;productAttempted=true;document.dispatchEvent(new Event('eb:shipping-quoted'));return;}
    }
    if(!force && key===productKey && Date.now()-productFetched<60000) return;
    const sequence=++productSequence;
    if(key!==productKey) productQuote=null;
    productKey=key;productLoading=true;productAttempted=true;
    document.dispatchEvent(new Event('eb:shipping-quoted'));
    try {
      const params=new URLSearchParams({country:cfg.country,variant:selection.variant,plan:selection.plan||''});
      const data=await quoteJSON(cfg.deliveryEstimateUrl+'?'+params,{credentials:'omit',cache:'no-store'});
      if(sequence!==productSequence) return;
      if(data.country!==cfg.country || data.currency!==cfg.currency || !Array.isArray(data.days) || data.days.length!==2 || !data.days.every(d=>Number.isInteger(d)&&d>=0) || data.days[1]<data.days[0]) throw new Error('Invalid delivery estimate');
      productQuote={days:data.days};productFetched=Date.now();
    } catch (_) {if(sequence===productSequence) {productQuote=null;productFetched=Date.now();}}
    finally {if(sequence===productSequence) {productLoading=false;document.dispatchEvent(new Event('eb:shipping-quoted'));}}
  }
  function scheduleProductQuote(selection=currentProductSelection(),force=false) {
    clearTimeout(productTimer);
    if(selection) productTimer=setTimeout(()=>quoteProduct(selection,force),150);
  }
  function deliveryHTML() {
    const dates=deliveryDates({...cfg,delivery:shippingQuote?.days?{days:shippingQuote.days}:null});
    if(!dates) return '';
    const showYear=dates.start && (dates.start.getUTCFullYear()!==new Date().getFullYear() || dates.end.getUTCFullYear()!==dates.start.getUTCFullYear());
    const format=d=>new Intl.DateTimeFormat(cfg.locale,{day:'numeric',month:'short',...(showYear?{year:'numeric'}:{}),timeZone:'UTC'}).format(d);
    const estimate=dates.start?t('delivery_estimate',{start:format(dates.start),end:format(dates.end)}).replace(/\.{2,}/g,'.'):(shippingLoading?t('loading'):t('at_checkout'));
    return '<div class="ebc-delivery"><p>'+(estimate?esc(estimate)+' <span aria-hidden="true">·</span> ':'')+'<button type="button" class="ebc-destination ebc-country" data-ebc-country aria-haspopup="dialog" aria-controls="regionModal" aria-label="'+esc(t('update_country')+': '+cfg.countryName)+'" title="'+esc(t('delivery_destination',{country:cfg.countryName}))+'">'+esc(cfg.countryName)+'<svg width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="m1 1 4 4 4-4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button></p></div>';
  }
  const body=el.querySelector('[data-ebc-body]'), footer=el.querySelector('[data-ebc-footer]'), status=el.querySelector('[data-ebc-status]');
  const pageBarObserver=isPage && typeof ResizeObserver!=='undefined'?new ResizeObserver(entries=>{document.documentElement.style.setProperty('--ebc-page-bar-height',Math.ceil(entries[0].target.getBoundingClientRect().height)+'px');}):null;
  function notify(message,error=false) { status.textContent=message; status.classList.toggle('ebc-error',error); }
  function openShell() {
    if(isPage) return;
    if (!el.open) { focusBefore=document.activeElement; el.showModal(); document.documentElement.classList.add('ebc-open'); }
  }
  function close() { if(isPage) return; el.close(); document.documentElement.classList.remove('ebc-open'); focusBefore?.focus?.(); }
  const editFetch=createEditTransport(document);
  async function api(path,payload,internalEdit=false) {
    const options={credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}};
    if (payload) { options.method='POST'; options.headers['Content-Type']='application/json'; options.body=JSON.stringify(payload); }
    const response=await (internalEdit?editFetch:window.fetch.bind(window))(root+path,options);
    const data=await response.json();
    if (!response.ok || data.status>=400) throw new Error(data.description || strings.error);
    return data;
  }
  async function refresh(preferredMarker) {
    cart=await api('cart.js');
    await normalizeBundle();
    const updates=mergeUpdates(cart.items,cfg.tiers,preferredMarker);
    if(Object.keys(updates).length) {await api('cart/update.js',{updates});cart=await api('cart.js');}
    if(shippingKey!==currentShippingKey()) shippingQuote=null;
    await quoteShipping(); return cart;
  }
  function bundleItems(items=cart?.items||[]) {
    return items.filter(item=>Object.values(cfg.tiers).some(tier=>String(tier.id)===String(item.variant_id||item.id)));
  }
  function singleBundleValid() {
    const items=bundleItems();
    return items.length<=1 && items.every(item=>item.quantity===1);
  }
  const storefrontWeeks=['4','6','8'];
  function firstOrderFrequencyValid() {
    return bundleItems().every(item=>!item.selling_plan_allocation||storefrontWeeks.includes(frequency(item,tierOf(item))));
  }
  function visibleItems() { return cart?.items||[]; }
  async function replaceMany(originals,payloads,trackAdd=false) {
    const markers=payloads.map(()=>crypto.randomUUID());
    const next=payloads.map((payload,i)=>({...payload,properties:{...payload.properties,_eb_cart_edit:markers[i]}}));
    let removalStarted=false;
    try {
      if(next.length) await api('cart/add.js',{items:next},!trackAdd);
      const live=await api('cart.js'),updates={};
      originals.forEach(({item,quantity})=>{
        const original=findCartLine(live.items,item);
        if(!original||original.quantity!==item.quantity) throw new Error('cart changed');
        updates[original.key]=original.quantity-quantity;
        if(updates[original.key]<0) throw new Error('invalid removal');
      });
      next.forEach((payload,i)=>{const added=live.items.find(item=>item.properties?._eb_cart_edit===markers[i]);if(!added||added.quantity!==payload.quantity) throw new Error('cart changed');});
      removalStarted=true;
      await api('cart/update.js',{updates},true);
      cart=await api('cart.js');
      originals.forEach(({item,quantity})=>{
        const current=findCartLine(cart.items,item),expected=item.quantity-quantity;
        if((current?.quantity||0)!==expected) throw new Error('incomplete replacement');
      });
    } catch(error) {
      // Roll back only if the source lines are intact. A response lost after a
      // successful update must not remove the already-paid-for replacement.
      const live=await api('cart.js');
      const intact=originals.every(({item})=>findCartLine(live.items,item)?.quantity===item.quantity);
      const applied=removalStarted&&originals.every(({item,quantity})=>(findCartLine(live.items,item)?.quantity||0)===item.quantity-quantity);
      if(!applied) {
        if(intact||!removalStarted) {
          const updates={};live.items.filter(item=>markers.includes(item.properties?._eb_cart_edit)).forEach(item=>updates[item.key]=0);
          if(Object.keys(updates).length) await api('cart/update.js',{updates},true);
        }
        throw error;
      }
      cart=live;
    }
    previous=null;editing=null;
    return markers.map(marker=>cart.items.find(item=>item.properties?._eb_cart_edit===marker));
  }
  function needsBundleNormalization(item) {
    return !!item.properties?._eb_pair_version || !!(tierOf(item) && splitOf(item,tierOf(item).size) && item.properties?._eb_flavour_label!==t('flavours'));
  }
  async function normalizeBundle() {
    for(const item of [...bundleItems()]) {
      if(!needsBundleNormalization(item)) continue;
      const props={...withoutPair(item).properties},split=splitOf(item,tierOf(item).size);
      if(split) {
        const text=names.map((name,i)=>split[i]?name+' '+split[i]+'×':'').filter(Boolean).join(', ');
        if(props._eb_flavour_label) delete props[props._eb_flavour_label];
        else Object.keys(props).filter(k=>!k.startsWith('_')&&props[k]===text).forEach(k=>delete props[k]);
        props[t('flavours')]=text;props._eb_flavour_label=t('flavours');
      }
      await api('cart/change.js',{id:item.key,quantity:item.quantity,properties:props},true);
      cart=await api('cart.js');
    }
  }
  function configuredPayload(payload) {
    return {...withoutPair(payload),quantity:1};
  }
  function tierOf(item) { return Object.values(cfg.tiers).find(q=>String(q.id)===String(item.variant_id) && q.data); }
  function button(action,label,extra='',className='ebc-link') {return '<button type="button" class="'+className+'" data-ebc-action="'+action+'" '+extra+'>'+esc(label)+'</button>';}
  function price(tier,weeks) {return weeks ? planFor(tier,weeks)?.price : tier.data.price;}
  function image(tier,item) {return '<img src="'+esc(tier?.data.image || item?.image || tier?.image)+'" width="94" height="104" alt="" loading="lazy">';}
  function flavourIcon(index) {
    const keys=['vanilla','chocolate','banana','blueberry'];
    const fallback=[
      '//everydaybar.com/cdn/shop/files/vanilla-peanut-pie_e3646bed-02a4-4cfc-a191-f0da2797e594.png?v=1777309912&width=200',
      '//everydaybar.com/cdn/shop/files/chocolate-sea-salt_c5e34ca0-ffa1-417a-9d21-b7bb52bbd2d2.png?v=1777310187&width=200',
      'https://cdn.shopify.com/s/files/1/0867/0973/1662/files/banana-choco-bliss.png?v=1785568722&width=200',
      'https://cdn.shopify.com/s/files/1/0867/0973/1662/files/lemon-blueberry-dream.png?v=1785568723&width=200'
    ];
    const picker=document.querySelector('.eb-fqty[data-flavor="'+keys[index]+'"]')?.closest('.eb-flavour-pick')?.querySelector('.eb-flavour-pick__img');
    return '<img src="'+esc(picker?.getAttribute('src') || fallback[index])+'" alt="" width="32" height="32" loading="lazy" decoding="async">';
  }
  function itemHTML(item,index) {
    const originalTier=tierOf(item), draft=editing?.key===item.key?editing:null, tier=draft?.size?cfg.tiers[draft.size]:originalTier, size=tier?.size, split=originalTier && splitOf(item,originalTier.size), weeks=originalTier && frequency(item,originalTier), subscribed=!!item.selling_plan_allocation;
    const displayPrice=draft?.size?price(tier,weeks):item.final_price;
    const compare=tier ? comparison(tier,rate()) : item.original_price;
    const sizeControl=tier && split && (!subscribed || weeks)?'<select class="ebc-size-select" data-ebc-size aria-label="'+esc(t('bundle_size'))+'">'+Object.values(cfg.tiers).filter(q=>q.data?.available && (!weeks || planFor(q,weeks))).map(q=>'<option value="'+q.size+'" '+(q.size===size?'selected':'')+'>'+esc(t('bars',{n:q.size}))+'</option>').join('')+'</select>':esc(tier?t('bars',{n:size}):item.variant_title||'');
    const quantityControl=tier&&item.quantity>1?'<p>'+esc(t('total_bars',{n:size*item.quantity}))+'</p>':'';
    const itemHeading=tier?'':'<div class="ebc-item-heading"><h3>'+esc(item.product_title)+'</h3>'+button('remove',t('remove'),'aria-label="'+esc(t('remove')+': '+item.product_title)+'"','ebc-link ebc-remove')+'</div>';
    let html='<article class="ebc-item" data-ebc-key="'+esc(item.key)+'">'+itemHeading+'<div class="ebc-product">'+image(tier,item)+'<div><div>'+sizeControl+'</div><div class="ebc-price"><strong>'+esc(money(displayPrice))+'</strong>'+(compare>displayPrice?'<del>'+esc(money(compare))+'</del>':'')+'</div>'+(tier?'<small>'+esc(t('per_bar',{price:money(Math.round(displayPrice/size))}))+'</small>':'')+'</div></div>'+quantityControl;
    if (tier && split && (!subscribed || weeks)) {
      const planOptions=storefrontWeeks.filter(w=>planFor(tier,w));
      html+='<div class="ebc-plan"><label><span>'+esc(t('subscription'))+'</span><select data-ebc-plan aria-label="'+esc(t('subscription'))+'"><option value="once" '+(!subscribed?'selected':'')+'>'+esc(t('once'))+'</option>';
      if(subscribed&&!storefrontWeeks.includes(weeks)) html+='<option value="" disabled selected>'+esc(t('subscription'))+'</option>';
      planOptions.forEach(w=>{html+='<option value="'+w+'" '+(weeks===w?'selected':'')+'>'+esc(t('weeks_'+w)||t('every_weeks',{n:w}))+'</option>';});
      html+='</select></label>'+(subscribed?'<p>'+esc(t('flexible'))+'</p>':'')+'</div>';
    } else if (subscribed) html+='<p>'+esc(item.selling_plan_allocation.selling_plan.name)+'</p>';
    if(index===0) html+=deliveryHTML();
    if (split) {
      const shown=editing?.key===item.key?editing.split:split, total=shown.reduce((a,b)=>a+b,0);
      html+='<div class="ebc-flavours ebc-flavours-listed"><div class="ebc-flavours-heading"><span>'+esc(t('flavours'))+'</span><span>'+total+' / '+size+'</span></div><ul class="ebc-flavour-list">';
      names.forEach((name,i)=>{html+='<li>'+flavourIcon(i)+'<span>'+esc(name)+(soldOutFlavours[i]?' <small>'+esc(cfg.soldOutLabel)+'</small>':'')+'</span><div class="ebc-inline-steps">'+button('flavour','−','data-index="'+i+'" data-delta="-7" '+(!shown[i]?'disabled':'')+' aria-label="'+esc(name+' −7')+'"')+'<b>'+shown[i]+'</b>'+button('flavour','+','data-index="'+i+'" data-delta="7" '+(soldOutFlavours[i] || total>=size?'disabled':'')+' aria-label="'+esc(name+' +7')+'"')+'</div></li>';});
      html+='</ul>'+(editing?.key===item.key?'<div class="ebc-mix-status">'+button('cancel',t('cancel'))+'</div>':'')+'</div>';
    } else {
      html+='<div class="ebc-flavours">'+Object.entries(item.properties||{}).filter(([k])=>!k.startsWith('_')).map(([k,v])=>esc(k+': '+v)).join('<br>')+'</div>';
    }
    let offer='';
    if (!item._pairParentKey && tier && split && item.quantity===1 && item.final_price===price(tier,weeks) && (!subscribed || weeks)) {
      const next=cfg.tiers[size*2], nextPrice=next && price(next,weeks);
      if (next?.data?.available && nextPrice && nextPrice>item.final_price) {
        const quote=verifiedUpgrade(next,weeks);
        const currentShipping=cart.total_price===cart.items.reduce((sum,line)=>sum+line.final_line_price,0) && shippingKey===currentShippingKey()?shippingQuote?.price:null;
        const delta=upgradeCost(nextPrice-item.final_price,currentShipping,quote);
        const discount=delta===null?0:addonDiscount(tier,rate(),delta);
        offer+='<div class="ebc-upgrade"><div class="ebc-offer-heading">'+(discount>0?'<span class="ebc-discount-circle" aria-label="'+esc(t('addon_discount',{n:next.size-size,percent:discount}))+'">−'+discount+'%</span>':'')+'<div class="ebc-offer-label">'+esc(t(size===14?'offer_larger_box':'offer_two_boxes'))+'</div></div><div class="ebc-upgrade-head">'+image(next)+'<div><h3>'+esc(t('upgrade_title',{n:next.size}))+'</h3>'+(delta===null?'':'<p>'+esc(t('extra',{n:next.size-size,price:money(Math.round(delta/(next.size-size)))}))+'</p>')+'</div></div>';
        offer+='<div class="ebc-offer-badges">';
        if(quote?.free) offer+='<span class="ebc-badge">✓ '+esc(t('free_shipping'))+'</span>';
        offer+='</div>';
        offer+=button('upgrade',delta===null?t('upgrade_title',{n:next.size}):t('upgrade',{n:next.size,price:money(delta)}),'','ebc-button')+'</div>';
      } else if (size===56 && !subscribed && planFor(tier,'4') && tier.data.price>planFor(tier,'4').price) {
        offer+='<div class="ebc-upgrade"><h3>'+esc(t('subscribe_save',{price:money(tier.data.price-planFor(tier,'4').price)}))+'</h3><p>'+esc(t('weeks_4'))+' · '+esc(t('flexible'))+'</p>'+button('subscribe',t('subscribe'),'','ebc-button')+'</div>';
      } else if (size===56) offer+='<div class="ebc-best">✓ '+esc(t('lowest'))+'</div>';
    }
    return html+offer+'</article>';
  }
  function discountCodes() {
    return (cart.discount_codes || []).filter(code=>code.applicable).map(code=>code.code);
  }
  function halloweenGiftHTML() {
    if (!bundleItems().length || cart.total_price <= 0 || !discountCodes().some(code => code.toUpperCase() === 'BOO4')) return '';
    return '<div class="ebc-halloween-gift" role="status"><span class="ebc-halloween-check" aria-hidden="true">✓</span><div><strong>'+esc(t('halloween_gift_title'))+'</strong><p>'+esc(t('halloween_gift_body'))+'</p></div></div>';
  }
  function discountHTML() {
    const codes=discountCodes();
    return '<div class="ebc-discount"><div class="ebc-discount-heading"><button type="button" class="ebc-discount-toggle" data-ebc-discount-toggle aria-expanded="'+discountExpanded+'" aria-controls="ebc-discount-entry">'+esc(t('discount_code'))+' <span aria-hidden="true">'+(discountExpanded?'−':'+')+'</span></button><div class="ebc-discount-codes">'+codes.map(code=>'<div class="ebc-discount-chip"><span>'+esc(code)+'</span><button type="button" data-ebc-discount-remove="'+esc(code)+'" aria-label="'+esc(t('remove')+': '+code)+'"'+(editing?' disabled':'')+'>×</button></div>').join('')+'</div></div><div id="ebc-discount-entry"'+(!discountExpanded?' hidden':'')+'><form data-ebc-discount-form><label class="ebc-discount-label" for="ebc-discount-code">'+esc(t('discount_code'))+'</label><div class="ebc-discount-entry"><input id="ebc-discount-code" name="discount" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="255" aria-describedby="ebc-discount-message" value="'+esc(discountDraft)+'"'+(editing?' disabled':'')+'><button type="submit"'+(editing?' disabled':'')+'>'+esc(t('discount_apply'))+'</button></div></form><p id="ebc-discount-message" class="ebc-discount-message'+(discountError?' ebc-discount-error':'')+'" role="status" aria-live="polite">'+esc(discountMessage)+'</p></div></div>';
  }
  async function updateDiscount(removeCode) {
    if(busy || editing) return;
    const code=discountDraft.trim();
    if(!removeCode && !code) {el.querySelector('#ebc-discount-code')?.focus();return;}
    setBusy(true);
    discountMessage=t('loading');discountError=false;
    render();
    try {
      cart=await api('cart.js');
      const codes=discountCodes().filter(value=>!removeCode || value.toLowerCase()!==removeCode.toLowerCase());
      if(!removeCode && !codes.some(value=>value.toLowerCase()===code.toLowerCase())) codes.push(code);
      await api('cart/update.js',{discount:codes.join(',')});
      cart=await api('cart.js');
      const applied=removeCode || discountCodes().some(value=>value.toLowerCase()===code.toLowerCase());
      discountError=!applied;
      discountMessage=applied?'':t('discount_invalid');
      if(applied) {discountDraft='';discountExpanded=false;}
      else discountExpanded=true;
      if(shippingKey!==currentShippingKey()) shippingQuote=null;
      document.dispatchEvent(new CustomEvent('eb:cart-updated',{detail:{cart}}));
      await quoteShipping();
    } catch (_) {
      discountError=true;discountExpanded=true;discountMessage=t('error');
    } finally {
      setBusy(false);render();
      el.querySelector(discountError?'#ebc-discount-code':'[data-ebc-discount-toggle]')?.focus();
    }
  }
  function bundleBarCount() {
    return bundleItems().reduce((sum,item)=>{
      const count=editing?.key===item.key?(editing.size||tierOf(item).size):tierOf(item).size;
      return sum+count*item.quantity;
    },0);
  }
  function boxHeading(count) {
    const forms=strings.box_heading;
    const form=count===0?'zero':new Intl.PluralRules(cfg.locale).select(count);
    return (forms[form]||forms.other).replaceAll('[n]',String(count));
  }
  function bundleProgressHTML() {
    const count=bundleBarCount(),milestones=[0,14,28,56],value=Math.min(56,Math.max(0,count));
    const segment=value<=14?value/14:value<=28?1+(value-14)/14:2+(value-28)/28;
    const percent=segment/3*100;
    return '<div class="ebc-bundle-progress"><div class="ebc-bundle-track" role="progressbar" aria-label="'+esc(boxHeading(count))+'" aria-valuemin="0" aria-valuemax="56" aria-valuenow="'+value+'" aria-valuetext="'+esc(t('bars',{n:count}))+'"><div class="ebc-bundle-line"><span style="width:'+percent+'%"></span></div>'+milestones.map(n=>'<span class="ebc-bundle-stop'+(n<=value?' is-reached':'')+(n===value?' is-current':'')+'" aria-hidden="true">'+n+'</span>').join('')+'</div></div>';
  }
  function render() {
    if (!cart || quoteRenderPending) return;
    el.querySelector('#eb-cart-title').textContent=boxHeading(bundleBarCount());
    const draftItem=editing?.size && bundleItems().find(item=>item.key===editing.key);
    const draftTier=draftItem && cfg.tiers[editing.size];
    const draftQuote=draftTier && cart.items.length===1 && draftItem.quantity===1 && !(cart.discount_codes||[]).some(code=>code.applicable) && verifiedUpgrade(draftTier,frequency(draftItem,tierOf(draftItem)));
    const shippingPrice=draftTier?(draftQuote?.free?0:null):shippingQuote?.price??null,free=shippingPrice===0;
    const shipping=el.querySelector('[data-ebc-shipping]');
    shipping.hidden=!cart.item_count || shippingPrice===null;
    const goal=freeShippingGoal(),totalBars=bundleBarCount();
    shipping.innerHTML='<strong>'+esc(free?'✓ '+t('free_shipping'):goal?t('shipping_goal',{n:Math.max(0,goal-totalBars)}):t('shipping')+': '+money(shippingPrice))+'</strong>'+(!free && goal?'<small>'+esc(t('shipping')+': '+money(shippingPrice))+'</small>':'');
    const nextBodyMarkup=bundleProgressHTML()+(!firstOrderFrequencyValid()?'<p class="ebc-pair-notice" role="status">'+esc(t('first_order_frequency'))+'</p>':'')+(cart.item_count?(!singleBundleValid()?'<p class="ebc-pair-notice" role="status">'+esc(t('single_bundle'))+'</p>':'')+visibleItems().map(itemHTML).join(''):'<div class="ebc-empty"><h3>'+esc(t('empty'))+'</h3><a class="ebc-button" href="'+esc(cfg.productUrl)+'">'+esc(t('continue'))+'</a></div>');
    if(nextBodyMarkup!==bodyMarkup) {body.innerHTML=nextBodyMarkup;bodyMarkup=nextBodyMarkup;}
    const saved=savings(cart.items,cfg.tiers,rate()) + Math.max(0,cart.items.reduce((sum,item)=>sum+item.final_line_price,0)-cart.total_price);
    const shippingPending=!!cart.item_count && !!cfg.delivery?.zip && (shippingLoading || shippingKey!==currentShippingKey());
    const shippingVerified=shippingQuote && shippingKey===currentShippingKey() && !shippingLoading;
    if(!cart.item_count) summarySnapshot=null;
    if(shippingVerified) summarySnapshot={country:cfg.country,currency:cart.currency,saved,regular:cart.total_price+saved,shipping:shippingPrice,total:cart.total_price+shippingPrice};
    const summary=shippingVerified || (shippingPending && summarySnapshot?.country===cfg.country && summarySnapshot?.currency===cart.currency)?summarySnapshot:null;
    const summarySaved=summary?.saved ?? saved;
    const summaryShipping=summary?summary.shipping===0?t('free_shipping'):money(summary.shipping):t(shippingPending?'loading':'at_checkout');
    const summaryTotal=editing?.size?t('remaining',{qty:editing.size-editing.split.reduce((a,b)=>a+b,0)}):summary?money(summary.total):t(shippingPending?'loading':'at_checkout');
    footer.hidden=!cart.item_count;
    const discountFocus=document.activeElement?.id==='ebc-discount-code', discountSelection=discountFocus?document.activeElement.selectionStart:null;
    const nextFooterMarkup=halloweenGiftHTML()+'<div class="ebc-footer-options">'+discountHTML()+'</div><div class="ebc-breakdown-content"><div class="ebc-summary"><span>'+esc(t('regular'))+'</span><del>'+esc(money(summary?.regular ?? cart.total_price+saved))+'</del></div><div class="ebc-summary ebc-saving"><span>'+esc(t('savings'))+'</span><strong>'+esc(money(summarySaved))+'</strong></div><div class="ebc-summary"><span>'+esc(t('shipping'))+'</span><span>'+esc(summaryShipping)+'</span></div></div><div class="ebc-summary ebc-total"><strong>'+esc(t('total'))+'</strong><strong>'+esc(summaryTotal)+'</strong></div>'+(shippingPending?'<p class="ebc-price-status" role="status" aria-live="polite">'+esc(t('loading'))+'</p>':'')+'<a class="ebc-checkout" href="'+root+'checkout" data-ebc-checkout>'+esc(t('checkout'))+' <span aria-hidden="true">→</span></a><div class="ebc-guarantee">✓ '+esc(t('guarantee'))+'</div>';

    const nextFooterKey=nextFooterMarkup+JSON.stringify(editing);
    const footerChanged=nextFooterKey!==footerMarkupKey;
    if(footerChanged) {footer.innerHTML=nextFooterMarkup;footerMarkupKey=nextFooterKey;}
    if(isPage && footerChanged) {
      const controls=document.createElement('div');
      controls.className='ebc-page-checkout-controls';
      Array.from(footer.children).filter(node=>node.matches('.ebc-total,.ebc-price-status,.ebc-checkout,.ebc-guarantee')).forEach(node=>controls.appendChild(node));
      footer.appendChild(controls);
      pageBarObserver?.disconnect();pageBarObserver?.observe(controls);
    }
    if(discountFocus) {const input=el.querySelector('#ebc-discount-code');input?.focus({preventScroll:true});input?.setSelectionRange(discountSelection,discountSelection);}
    document.querySelectorAll('#cart-icon-bubble').forEach(icon=>{
      let bubble=icon.querySelector('.cart-count-bubble');
      if (!bubble) {bubble=document.createElement('div');bubble.className='cart-count-bubble';icon.appendChild(bubble);}
      bubble.textContent='';bubble.setAttribute('aria-hidden','true');bubble.hidden=!cart.item_count;
      icon.setAttribute('aria-label',t('title')+(cart.item_count?', '+t('bars',{n:bundleBarCount()}):''));
    });
    if(editing) {
      if(editing.size) {el.querySelector('.ebc-breakdown-content')?.setAttribute('hidden','');const total=el.querySelector('.ebc-total');if(total) total.style.display='none';}
      el.querySelectorAll('[data-ebc-plan], [data-ebc-action="subscribe"], [data-ebc-action="increase"], [data-ebc-action="decrease"], [data-ebc-action="undo"]').forEach(node=>node.disabled=true);
      el.querySelectorAll('[data-ebc-size], [data-ebc-action="upgrade"]').forEach(node=>node.disabled=node.disabled||node.closest('[data-ebc-key]')?.dataset.ebcKey!==editing.key);
      const checkout=el.querySelector('[data-ebc-checkout]');
      if(checkout) {
        const item=visibleItems().find(i=>i.key===editing.key),remaining=(editing.size||tierOf(item)?.size||0)-editing.split.reduce((a,b)=>a+b,0);
        checkout.textContent=remaining>0?t('remaining',{qty:remaining}):t('loading');
        checkout.setAttribute('aria-disabled','true');checkout.setAttribute('tabindex','-1');checkout.removeAttribute('href');
      }
    }
    if(!singleBundleValid()) {
      const checkout=el.querySelector('[data-ebc-checkout]');
      if(checkout) {checkout.textContent=t('single_bundle');checkout.setAttribute('aria-disabled','true');checkout.setAttribute('tabindex','-1');checkout.removeAttribute('href');}
    }
    if(!firstOrderFrequencyValid()) {
      const checkout=el.querySelector('[data-ebc-checkout]');
      if(checkout) {checkout.textContent=t('first_order_frequency');checkout.setAttribute('aria-disabled','true');checkout.setAttribute('tabindex','-1');checkout.removeAttribute('href');}
    }
    if(shippingPending && !editing) {
      const checkout=el.querySelector('[data-ebc-checkout]');
      if(checkout) {checkout.textContent=t('loading');checkout.setAttribute('aria-disabled','true');checkout.setAttribute('tabindex','-1');checkout.removeAttribute('href');}
    }
    footer.setAttribute('aria-busy',String(shippingPending));
    setBusy(busy);
    if(isPage) {
      el.hidden=false;el.classList.toggle('ebc-page-empty',!cart.item_count);
      document.documentElement.classList.add('ebc-page-ready');
      if(status.hasAttribute('data-ebc-initial-loading')) {status.textContent='';status.removeAttribute('data-ebc-initial-loading');}
      if(!el.hasAttribute('data-ebc-ready')) {el.setAttribute('data-ebc-ready','');document.dispatchEvent(new Event('eb:cart-page-ready'));}
    }
  }
  function setBusy(value) {
    busy=value; el.setAttribute('aria-busy',String(value));
    body.inert=value; footer.inert=value;
    el.classList.toggle('ebc-busy',value);
  }
  async function run(fn) {
    if (busy) return;
    setBusy(true); notify(t('loading'));
    try { await fn(); notify(''); }
    catch (_) { try { await refresh(); } catch (_) {} notify(t('error'),true); }
    finally { setBusy(false); }
  }
  async function currentItem(key) {
    cart=await api('cart.js');
    const item=visibleItems().find(i=>i.key===key);
    if (!item) throw new Error('cart changed');
    return item;
  }
  function publishChangedItem(marker) {
    document.dispatchEvent(new CustomEvent('eb:cart-updated',{detail:{cart,item:cart.items.find(i=>i.properties?._eb_cart_edit===marker)}}));
  }
  async function replace(item,payload,remember=true) {
    payload=configuredPayload(payload);
    if(tierOf(item) && bundleItems().length>1) {
      await replaceMany(bundleItems().map(item=>({item,quantity:item.quantity})),[payload]);
      await refresh();return;
    }
    const marker=crypto.randomUUID();
    const old={id:item.variant_id,quantity:item.quantity,properties:{...item.properties}};
    if(item.selling_plan_allocation) old.selling_plan=item.selling_plan_allocation.selling_plan.id;
    const next={...payload,properties:{...payload.properties,_eb_cart_edit:marker}};
    let removalAttempted=false;
    try {
      await api('cart/add.js',{items:[next]},true);
      const afterAdd=await api('cart.js');
      const original=findCartLine(afterAdd.items,item);
      const added=afterAdd.items.find(i=>i.properties?._eb_cart_edit===marker);
      if (!original || original.quantity!==item.quantity || !added || added.quantity!==payload.quantity) throw new Error('cart changed');
      removalAttempted=true;
      await api('cart/change.js',{id:original.key,quantity:0});
    } catch (error) {
      try {
        const live=await api('cart.js');
        const added=live.items.find(i=>i.properties?._eb_cart_edit===marker);
        const original=findCartLine(live.items,item);
        if(added && (original || !removalAttempted)) await api('cart/change.js',{id:added.key,quantity:0});
        else if(added && !original && removalAttempted) { await refresh(marker); previous=remember?{marker,payload:old}:null; publishChangedItem(marker); return; }
      } catch (_) {}
      throw error;
    }
    previous=remember?{marker,payload:old}:null; editing=null;
    await refresh(marker);
    publishChangedItem(marker);
  }
  function trackAcceptedUpgrade(data) {
    if(!data) return;
    try {
      const result=window.Shopify?.analytics?.publish?.('everyday_bar:box_upgrade_accepted',data);
      if(result && typeof result.catch==='function') result.catch(()=>{});
    } catch (_) { /* Measurement must never interrupt the cart. */ }
    const privacy=window.Shopify?.customerPrivacy,eventId=crypto.randomUUID();
    try {
      const analyticsAllowed=privacy?.analyticsProcessingAllowed?.()===true;
      const marketingAllowed=privacy?.marketingAllowed?.()===true && privacy?.saleOfDataAllowed?.()===true;
      const payload={offer_id:data.offer_id,from_box_size:data.from_box_size,to_box_size:data.to_box_size,purchase_type:data.purchase_type,subscription_weeks:data.subscription_weeks,quantity:data.quantity,currency:data.currency,value:data.value};
      const meta=analyticsAllowed && marketingAllowed && typeof window.fbq==='function';
      const google=analyticsAllowed && typeof window.gtag==='function';
      if(meta) window.fbq('trackSingleCustom','1663452400989503','BoxUpgradeAccepted',payload,{eventID:eventId});
      if(google) window.gtag('event','box_upgrade_accepted',{...payload,send_to:'G-8Z1PKB6ENT',event_id:eventId});
      console.info('[EB upgrade delivery]',JSON.stringify({meta,google,analyticsAllowed,marketingAllowed}));
    } catch (_) { /* Existing consent-controlled integrations remain authoritative. */ }
  }
  async function actionSave(key) { return action('save',key); }
  async function action(action,key,target) {
    if(['increase','decrease'].includes(action)) return;
    if(action==='edit') {const item=visibleItems().find(i=>i.key===key);editing={key,split:splitOf(item,tierOf(item).size)};render();return;}
    if(action==='cancel') {editing=null;render();return;}
    if(action==='flavour') {
      const item=visibleItems().find(i=>i.key===key),size=editing?.key===key&&editing.size?editing.size:tierOf(item)?.size;
      if (!size || (editing && editing.key!==key)) return;
      if (!editing) editing={key,split:splitOf(item,size)};
      const index=Number(target.dataset.index),delta=Number(target.dataset.delta),total=editing.split.reduce((a,b)=>a+b,0);
      if ((soldOutFlavours[index] && delta>0) || !Number.isInteger(index) || index<0 || index>3 || ![-7,7].includes(delta) || editing.split[index]+delta<0 || total+delta>size) return;
      editing.split[index]+=delta; render();
      if(editing.split.reduce((a,b)=>a+b,0)===size) await actionSave(key);
      return;
    }
    if(editing && (!['save','remove','size','upgrade'].includes(action) || (['size','upgrade'].includes(action) && editing.key!==key))) return;
    await run(async()=>{
      if(action==='undo') {
        const snapshot=previous; if(!snapshot) return;
        cart=await api('cart.js'); const item=cart.items.find(i=>i.properties?._eb_cart_edit===snapshot.marker);
        if(!item) throw new Error('cart changed');
        await replace(item,snapshot.payload,false); return;
      }
      const item=await currentItem(key),tier=tierOf(item);
      if(action==='remove') {
        await api('cart/change.js',{id:item.key,quantity:0});previous=null;editing=null;await refresh();return;
      }
      const weeks=frequency(item,tier),split=splitOf(item,tier.size);
      let size=action==='save'&&editing?.size?editing.size:tier.size,nextWeeks=weeks;
      if(action==='upgrade') size=(editing?.size||tier.size)*2;
      if(action==='size') size=Number(target.value);
      if(![14,28,56].includes(size)) throw new Error('invalid size');
      if(action==='size'&&size===tier.size&&!editing&&item.quantity===1&&singleBundleValid()) return;
      if(action==='subscribe') nextWeeks='4';
      if(action==='plan') nextWeeks=target.value==='once'?null:target.value;
      if(nextWeeks&&!storefrontWeeks.includes(String(nextWeeks))) throw new Error('unavailable frequency');
      const next=cfg.tiers[size];
      if(!next?.data?.available || !split) throw new Error('unavailable');
      if(item.selling_plan_allocation && !weeks) throw new Error('unknown subscription');
      const plan=nextWeeks && planFor(next,nextWeeks);
      if(nextWeeks && !plan) throw new Error('unavailable plan');
      const nextSplit=action==='save'?editing.split:['upgrade','size'].includes(action)?resizedSplit(editing?.key===item.key?editing.split:split,editing?.size||tier.size,size):split;
      if(nextSplit.reduce((a,b)=>a+b,0)<size) {
        editing={key:item.key,size,split:nextSplit};render();return;
      }
      const payload={id:next.id,quantity:item.quantity,properties:propertiesFor(item,size,nextSplit,t('flavours'))};
      if(plan) payload.selling_plan=plan.id;
      const beforeTotal=cart.total_price;
      await replace(item,payload);
      if(action==='upgrade') {
        const updated=cart.items.find(line=>String(line.variant_id)===String(next.id) && splitOf(line,size)?.every((n,i)=>n===nextSplit[i]) && String(line.selling_plan_allocation?.selling_plan?.id||'')===String(plan?.id||''));
        const event=upgradeEvent(item,updated,tier.size,size,cart.currency,cart.total_price-beforeTotal);
        if(event) { event.subscription_weeks=Number(nextWeeks)||0; trackAcceptedUpgrade(event); }
      }
    });
    if(action==='size') el.querySelector('[data-ebc-size]')?.focus({preventScroll:true});
  }
  const countryReturnKey='eb-cart-country-return';
  let regionFromCart=false;
  function openCountrySelector() {
    const opener=document.getElementById('regionBtn'),modal=document.getElementById('regionModal');
    if(!opener || !modal || busy) return;
    regionFromCart=true;
    const observer=new MutationObserver(()=>{
      if(!modal.hidden) return;
      observer.disconnect();
      if(regionFromCart) {regionFromCart=false;openShell();el.querySelector('[data-ebc-country]')?.focus();}
    });
    observer.observe(modal,{attributes:true,attributeFilter:['hidden']});
    close();opener.click();
  }
  document.addEventListener('submit',event=>{
    if(event.target.id!=='HeaderRegionForm' || !regionFromCart) return;
    const item=editing && visibleItems().find(i=>i.key===editing.key);
    const draft=item?{key:item.key,variant:item.variant_id,plan:item.selling_plan_allocation?.selling_plan?.id||'',original:splitOf(item,tierOf(item)?.size),size:editing.size,split:editing.split}:null;
    try {sessionStorage.setItem(countryReturnKey,JSON.stringify({at:Date.now(),country:event.target.querySelector('[name="country_code"]')?.value,draft}));} catch (_) {}
  });
  async function reopenLocalizedCart() {
    let saved;
    try {saved=JSON.parse(sessionStorage.getItem(countryReturnKey));sessionStorage.removeItem(countryReturnKey);} catch (_) {return;}
    if(!saved || Date.now()-saved.at>120000 || saved.country!==cfg.country) return;
    await window.EBCart.open();
    const draft=saved.draft;
    if(!draft || !Array.isArray(draft.split) || draft.split.length!==4 || draft.split.some(n=>!Number.isInteger(n)||n<0||n%7)) return;
    const item=visibleItems().find(i=>i.key===draft.key) || visibleItems().find(i=>String(i.variant_id)===String(draft.variant) && String(i.selling_plan_allocation?.selling_plan?.id||'')===String(draft.plan) && JSON.stringify(splitOf(i,tierOf(i)?.size))===JSON.stringify(draft.original));
    if(item && [14,28,56].includes(draft.size||tierOf(item)?.size) && draft.split.reduce((a,b)=>a+b,0)<=(draft.size||tierOf(item)?.size)) {editing={key:item.key,size:draft.size,split:draft.split};render();}
  }
  el.addEventListener('submit',event=>{if(event.target.matches('[data-ebc-discount-form]')) {event.preventDefault();updateDiscount();}});
  el.addEventListener('input',event=>{if(event.target.id==='ebc-discount-code') discountDraft=event.target.value;});
  el.addEventListener('click',event=>{
    if(event.target.closest('[data-ebc-discount-toggle]')) {if(!busy) {discountExpanded=!discountExpanded;render();el.querySelector(discountExpanded?'#ebc-discount-code':'[data-ebc-discount-toggle]')?.focus();}return;}
    const removeDiscount=event.target.closest('[data-ebc-discount-remove]');
    if(removeDiscount) {updateDiscount(removeDiscount.dataset.ebcDiscountRemove);return;}
    if(event.target.closest('[data-ebc-country]')) {openCountrySelector();return;}
    if(event.target.closest('[data-ebc-checkout]')) {
      event.preventDefault();
      if(!busy&&!editing) run(async()=>{await refresh();if(!singleBundleValid()) {notify(t('single_bundle'),true);return;}if(!firstOrderFrequencyValid()) {notify(t('first_order_frequency'),true);return;}window.location.assign(root+'checkout');});
      return;
    }
    if(event.target===el || event.target.closest('[data-ebc-close]')) {close();return;}
    const target=event.target.closest('[data-ebc-action]');
    if(target && !busy) action(target.dataset.ebcAction,target.closest('[data-ebc-key]')?.dataset.ebcKey,target);
  });
  el.addEventListener('change',event=>{if(event.target.matches('[data-ebc-size]')) action('size',event.target.closest('[data-ebc-key]').dataset.ebcKey,event.target);if(event.target.matches('[data-ebc-plan]')) action('plan',event.target.closest('[data-ebc-key]').dataset.ebcKey,event.target);});
  el.addEventListener('cancel',event=>{event.preventDefault();close();});
  el.addEventListener('keydown',event=>{
    if(isPage || event.key!=='Tab') return;
    const nodes=Array.from(el.querySelectorAll('button:not([disabled]),a[href],select,input:not([disabled]),summary')).filter(n=>n.getClientRects().length && !n.closest('[inert]'));
    if(event.shiftKey && document.activeElement===nodes[0]) {nodes.at(-1)?.focus();event.preventDefault();}
    else if(!event.shiftKey && document.activeElement===nodes.at(-1)) {nodes[0]?.focus();event.preventDefault();}
  });
  window.EBCart={
    dispatchDate:(now=new Date())=>deliveryDates(cfg,now)?.dispatch,
    deliveryDispatchLabel:()=>{
      const date=deliveryDates(cfg)?.dispatch;
      return date?t('dispatch_date',{date:new Intl.DateTimeFormat(cfg.locale,{day:'numeric',month:'short',year:'numeric',timeZone:'UTC'}).format(date)}):'';
    },
    deliveryEstimate:()=>{
      if(!productQuote?.days || cfg.shippingMode==='hidden') return productLoading||!productAttempted?t('loading'):t('at_checkout');
      const dates=deliveryDates({...cfg,delivery:{days:productQuote.days}});
      const showYear=dates.start.getUTCFullYear()!==new Date().getFullYear() || dates.end.getUTCFullYear()!==dates.start.getUTCFullYear();
      const format=d=>new Intl.DateTimeFormat(cfg.locale,{day:'numeric',month:'short',...(showYear?{year:'numeric'}:{}),timeZone:'UTC'}).format(d);
      return t('delivery_estimate',{start:format(dates.start),end:format(dates.end)}).replace(/\.{2,}/g,'.');
    },
    open:async()=>{openShell();await run(refresh);},
    add:async(payload,btn)=>{
      if(busy) return;
      payload=configuredPayload(payload);
      btn.disabled=true; openShell();
      await run(async()=>{
        cart=await api('cart.js');
        const selectedTier=Object.values(cfg.tiers).find(tier=>String(tier.id)===String(payload.id));
        if(payload.selling_plan&&!storefrontWeeks.some(weeks=>String(selectedTier?.planIds[weeks])===String(payload.selling_plan))) throw new Error('unavailable frequency');
        // A new selection replaces the previous bundle, never adds another.
        const originals=bundleItems().map(item=>({item,quantity:item.quantity}));
        if(originals.length) await replaceMany(originals,[payload],true);
        else await api('cart/add.js',{items:[payload]});
        previous=null;editing=null;await refresh();document.dispatchEvent(new CustomEvent('eb:cart-updated',{detail:{cart}}));
      });
      btn.disabled=false;
    }
  };
  document.dispatchEvent(new Event('eb:cart-ready'));
  if(isPage) document.dispatchEvent(new Event('eb:cart-initializing'));
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',reopenLocalizedCart,{once:true});
  else reopenLocalizedCart();
  window.addEventListener('pageshow',reopenLocalizedCart);
  document.addEventListener('eb:purchase-selection',event=>scheduleProductQuote(event.detail));
  document.addEventListener('DOMContentLoaded',()=>scheduleProductQuote());
  if(document.readyState!=='loading') scheduleProductQuote();
  window.addEventListener('pageshow',()=>scheduleProductQuote(undefined,true));
  // History can reuse cached HTML without restoring the JavaScript heap.
  // Its embedded cart may predate edits made before entering checkout.
  const historyNavigation=window.performance?.getEntriesByType('navigation')[0]?.type==='back_forward';
  const initialCart=isPage && !historyNavigation && cfg.initialCart;
  // Liquid cart JSON can omit discount_codes. Fetch Ajax cart data before confirming gifts.
  if(initialCart && Array.isArray(initialCart.discount_codes) && Array.isArray(initialCart.items) && Number.isFinite(initialCart.total_price) && typeof initialCart.currency==='string') {
    cart=initialCart;
    if(bundleItems().some(needsBundleNormalization)) run(refresh);
    else quoteShipping().catch(()=>document.dispatchEvent(new Event('eb:cart-page-failed')));
  } else {
    api('cart.js').then(initial=>{if(!cart && !busy) {cart=initial;if(bundleItems().some(needsBundleNormalization)) run(refresh);else quoteShipping().catch(()=>document.dispatchEvent(new Event('eb:cart-page-failed')));}}).catch(()=>{if(isPage) document.dispatchEvent(new Event('eb:cart-page-failed'));});
  }
  function refreshDeliveryNotice() {
    if(!isPage && !el.open) return;
    const notice=el.querySelector('.ebc-delivery');
    if(notice) notice.outerHTML=deliveryHTML();
  }
  window.setInterval(()=>{refreshDeliveryNotice();if((isPage || el.open) && !document.hidden && !busy && !editing) quoteShipping();if(!document.hidden) scheduleProductQuote(undefined,true);},60000);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden) {refreshDeliveryNotice();scheduleProductQuote(undefined,true);}});
  document.addEventListener('click',event=>{
    const link=event.target.closest('#cart-icon-bubble, [data-eb-cart-open]');
    if(link) {
      event.preventDefault();event.stopImmediatePropagation();
      if(isPage) {el.scrollIntoView({block:'start'});el.querySelector('#eb-cart-title')?.focus({preventScroll:true});return;}
      window.EBCart.open();
    }
  },true);
  window.addEventListener('pageshow',event=>{if(event.persisted && (isPage || el.open)) window.EBCart.open();});
})();
